
export const Routes = {
    Signin: { path: "/sign-in" },
    Signup: { path: "/sign-up" },
    ForgotPassword: { path: "/forgot-password" },
    ResetPassword: { path: "/reset-password" },
    Lock: { path: "/examples/lock" },
    NotFound: { path: "/not-found-404" },
    ServerError: { path: "/server-error-500" },
    // pages
    Presentation: { path: "/" },
    Dashboard: { path: "/dashboard" },
    DashboardTraffic: { path: "/dashboard/traffic-and-engagement" },
    DashboardProductAnalysis: { path: "/dashboard/product-analysis" },

    CampaignAnalytics: { path: "/campaign-analytics" },
    FailOverAnalytics: { path: "/failover-analytics" },
    SMSReports: { path: "/reports-sms" },
    WhatsAppReports: { path: "/reports-whatsapp" },
    RCSReports: { path: "/reports-rcs" },

    UserManagement: { path: "/user-management" },
    CreateUserManagement: { path: "/user-management/user-onboarding" },

    SMSSMPPAccount: { path: "/sms-registration" },
    CreateSMS: { path: "/sms-registration/create-sms" },

    SMSCRegistration: { path: "/smsc-registration" },
    CreateSMSC: { path: "/smsc-registration/create-smsc" },

    SMSCRates: { path: "/smsc-rate-management" },
    CreateSMSCRateManagement: { path: "/smsc-rate-management/create-rate-management" },

    SenderIDRegistration: { path: "/sender-id" },
    CreateSenderId: { path: "/sender-id/create-sender-id" },

    RoutesMapping: { path: "/route-mapping" },
    CreateMapping: { path: "/route-mapping/create-route-mapping" },
    ReportingUser: { path: "/ru-mapping" },
    CreateRUMapping: { path: "/ru-mapping/create-ru-mapping" },

    VendorManagement: { path: "/vendor-management" },
    CreateVendorOnboarding: { path: "/vendor-management/create-vendor" },

    Routing: { path: "/default-routing" },
    CreateDefaultRouting: { path: "/default-routing/create-default-routing" },
    CreateDefaultRoutingSMSC: { path: "/default-routing/create-default-routing/SMSC" },

    EnterpriseWallet: { path: "/enterprise-wallet" },
    VendorWallet: { path: "/vendor-wallet" },
    
    ChannelTesting: { path: "/channel-testing" },

    ESMEList: { path: "/monitor-esme-list" },
    SMSCList: { path: "/monitor-smsc-list" },

    ContactList: { path: "/contact-list" },
    
    Templates: { path: "/templates" },
    CreateTemplate: { path: "/templates/template-create" },

    Campaign: { path: "/campaigns" },
    CreateCampaign: { path: "/campaigns/campaign-create" },
    
    WABSPs: { path: "/whatsapp-bsp" },
    WARates: { path: "/whatsapp-rates" },

    RCSBSPs: { path: "/rcs-bsp" },
    RCSRates: { path: "/rcs-rates"},

    ConfigAPIToken: { path: "/configurations/api-token" },
    ConfigAPIDocs: { path: "/configurations/api-docs" },
    ConfigDLRWebhook: { path: "/configurations/dlr-webhook" },
    
    WAProfiles: { path: "/wa-profiles" },
    ChatBot: { path: "/chatBot" },
    ChatBotApi: { path: "/chatBot/add-api"},
    ChatFlowScreen: { path: "/chatBot/create-flow" },




    Messages: { path: "/messages" },
    SingleMessage: { path: "/message" },
    Users: { path: "/users" },
    Transactions: { path: "/transactions" },
    Tasks: { path: "/tasks" },
    Settings: { path: "/settings" },
    Calendar: { path: "/calendar" },
    Map: { path: "/map" },
    Datatables: { path: "/tables/datatables" },
    BootstrapTables: { path: "/tables/bootstrap-tables" },
    Pricing: { path: "/examples/pricing" },
    Billing2: { path: "/examples/billing" },
    Invoice: { path: "/examples/invoice" },


    // docs
    DocsOverview: { path: "/documentation/overview" },
    DocsDownload: { path: "/documentation/download" },
    DocsQuickStart: { path: "/documentation/quick-start" },
    DocsLicense: { path: "/documentation/license" },
    DocsFolderStructure: { path: "/documentation/folder-structure" },
    DocsBuild: { path: "/documentation/build-tools" },
    DocsChangelog: { path: "/documentation/changelog" },

    // plugins
    PluginCharts: { path: "/plugins/charts" },
    PluginCalendar: { path: "/plugins/calendar" },
    PluginDatatable: { path: "/plugins/datatable" },
    PluginMap: { path: "/plugins/map" },
    PluginDropzone: { path: "/plugins/dropzone" },
    PluginSweetAlert: { path: "/plugins/sweet-alert" },
};